import React, { useEffect, useState } from "react";
import "./Download_offcanvas.css";
import { Offcanvas, Button } from "react-bootstrap";
import Common_Back_Btn from "../../common_components/common_back_btn/Common_Back_Btn";
import Success_Toster from "../../common_modal/success_toster/Success_Toster";

function Download_offcanvas({
  show,
  handleClose,
  onConfirm,
  offcanvasHeading,
  massageText,
}) {
  const [success, setSuccess] = useState(false);

  // ⏱ auto hide success toaster after 3 sec
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
        handleClose();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [success, handleClose]);

  const handleYes = () => {
    if (onConfirm) {
      onConfirm(); // trigger download
    }
    setSuccess(true);
  };

  return (
    <Offcanvas
      className="mobile_offcanvas confirmation_offcanvas common_offcanvas"
      show={show}
      placement="end"
      onHide={handleClose}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          <div className="back_div" onClick={handleClose}>
            <Common_Back_Btn />
          </div>
          {offcanvasHeading}
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <div className="text_holder">
          <p>
            Are you sure you want to <span>Download</span> the {massageText}{" "}
            document file?
          </p>
        </div>

        <div className="permission_btn_holder">
          {success ? (
            <Success_Toster successText="Download File Successfully!" />
          ) : (
            <>
              <Button
                type="button"
                className="permission_btn No_btn"
                onClick={handleClose}
              >
                No
              </Button>

              <Button
                type="button"
                className="permission_btn Yes_btn"
                onClick={handleYes}
              >
                Yes
              </Button>
            </>
          )}
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default Download_offcanvas;
